import type { TokenPayload } from '../types/auth';

/**
 * Token 存储 — 按 app basePath 命名空间隔离
 * 同一域名下 9 个子系统各自独立的 token，互不覆盖
 */
function getAppPrefix(): string {
  // 从 URL 路径提取 app 标识: /bank/xxx → bank, /scenic/xxx → scenic
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const segments = path.split('/').filter(Boolean);
  const app = segments[0] || 'portal';
  return `kxdex_${app}`;
}

function walletAddressKey(): string {
  return `${getAppPrefix()}_wallet_address`;
}

export function decodeJwt(token: string): TokenPayload | null {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload) as TokenPayload;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const payload = decodeJwt(token);
  if (!payload) return true;
  return payload.exp * 1000 < Date.now() + 30_000;
}

export function getAccessToken(): string | null {
  return null;
}

export function setAccessToken(_token: string): void {
}

export function getRefreshToken(): string | null {
  return null;
}

export function setRefreshToken(_token: string): void {
}

export function clearTokens(): void {
}

export function setTokens(_accessToken: string, _refreshToken: string): void {
}

export function getWalletAddress(): string | null {
  return localStorage.getItem(walletAddressKey());
}

export function setWalletAddress(address: string): void {
  localStorage.setItem(walletAddressKey(), address);
}
